import React from 'react';

function WeedingPic() {
  return (
    <div className="Part2">
      <div className="PicW">
        <img 
          src="https://img.perniaspopupshop.com/wysiwyg/WEDDING/Pheras_24-06-22.jpg" 
          alt="Wedding Outfit" 
        />
      </div>

      <div className="TextW">
        <h2>Elegance Redefined: The Perfect Wedding Attire</h2>
        <p>
          Choosing the perfect wedding outfit is a reflection of grace and tradition. Our 
          collection features luxurious fabrics, intricate embroidery, and modern designs 
          tailored to perfection. Whether you're looking for a grand sherwani, a stunning 
          lehenga, or a contemporary Indo-western outfit, we have the perfect ensemble for you. 
          <br /><br />
          Our designs are inspired by heritage but crafted for the modern bride and groom. 
          Each outfit is meticulously detailed to ensure elegance and comfort. Explore our 
          range of rich silk, royal velvet, and handwoven fabrics that promise a regal 
          presence on your special day.
          <br /><br />
          **A Perfect Blend of Tradition & Modernity**  
          Our collection is designed to reflect cultural values while embracing contemporary 
          trends. We offer a variety of wedding attires ranging from heavily embroidered lehengas 
          to simple yet elegant sarees and stylish Indo-western outfits for both men and women. 
          <br /><br />
          The traditional red bridal lehenga is always a timeless choice, symbolizing love 
          and prosperity. However, pastel hues, floral embroidery, and intricate sequins 
          have taken the modern wedding scene by storm. Whether you prefer a vibrant look 
          or a subtle pastel palette, our collection offers something unique for every bride.
          <br /><br />
          **Premium Fabrics & Handcrafted Detailing**  
          Our wedding outfits are crafted from high-quality fabrics, ensuring both comfort 
          and durability. We use silk, velvet, brocade, and organza, adorned with exquisite 
          embroidery, zari work, and Swarovski crystals to enhance the grandeur of each 
          piece. Every outfit is tailored to perfection, ensuring a flawless fit and 
          unmatched elegance.
        </p>
      </div>
    </div>
  );
}

export default WeedingPic;
